import { render, staticRenderFns } from "./seeClassCurriculumParameterInfo.vue?vue&type=template&id=744ee735"
import script from "./seeClassCurriculumParameterInfo.vue?vue&type=script&lang=js"
export * from "./seeClassCurriculumParameterInfo.vue?vue&type=script&lang=js"
import style0 from "./seeClassCurriculumParameterInfo.vue?vue&type=style&index=0&id=744ee735&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports